import BasicTooltipExample from "./examples/BasicTooltip.Example";
import CustomRenderTooltipExample from "./examples/CustomRenderTooltip.Example";
import OverflowTooltipExample from "./examples/OverflowTooltip.Example";

export default [
    {
        title: "Basic Tooltip example",
        component: BasicTooltipExample,
        code: require("!raw-loader!./examples/BasicTooltip.Example.tsx")
    },
    {
        title: "Custom Render Tooltip example",
        component: CustomRenderTooltipExample,
        code: require("!raw-loader!./examples/CustomRenderTooltip.Example.tsx")
    },
    {
        title: "Overflow Tooltip example",
        component: OverflowTooltipExample,
        code: require("!raw-loader!./examples/OverflowTooltip.Example.tsx")
    }
];
